import api from './client'

// Portal del cliente — "mi cuenta" pública por token permanente (sin login).
export const portalApi = {
  solicitarAcceso: (email) => api.post('/publico/portal/solicitar-acceso', { email }),
  obtener: (token) => api.get(`/publico/portal/${token}`),
}
